'use strict';
var $ = require('../internals/export');
var exec = require('../internals/regexp-exec');

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.regexp.exec.js
// module id = 54
// module chunks = 0